import { render } from "./MedNyttStartPage.vue?vue&type=template&id=603f790b"
import script from "./MedNyttStartPage.vue?vue&type=script&lang=js"
export * from "./MedNyttStartPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__